// Visor master volume (the player bar's volume button). Media that manages
// its own output — ReactPlayer's controlled `volume` prop, wavesurfer's
// WebAudio backend, AudioCue's detached `new Audio()` — can't be reached (or
// re-overrides) a DOM `el.volume` sweep, so those components multiply this
// master into their own volume and re-render on change.
let master = 1;
const subs = new Set();

export function setMasterVolume(v) {
  master = Math.max(0, Math.min(1, v));
  subs.forEach((cb) => {
    try {
      cb(master);
    } catch (_) {}
  });
}

export function getMasterVolume() {
  return master;
}

export function onMasterVolume(cb) {
  subs.add(cb);
  return () => subs.delete(cb);
}
